module.exports = __webpack_public_path__ + "static/media/covid-act-now-logo-url-dark.234d37a8.png";